import AssessmentsSerializer from './base';

export default class Assessment extends AssessmentsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      sequence: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
